/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation CustomerAccountDeleteAllMutation($customerAccountIds: [ID!]!) {
  CustomerAccountDeleteAll(customerAccountIds: $customerAccountIds) {
    id
    message
    status
  }
}
`
